import { render, staticRenderFns } from "./SearchModel.vue?vue&type=template&id=4c709afb&"
import script from "./SearchModel.vue?vue&type=script&lang=js&"
export * from "./SearchModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports